<t4-list-view #listVw [options]="listOptions" (onDataRequest)="setListItems()">
  <ng-container *t4ListItem="let item">
    <ng-container>
      <td class="p-6">#{{item.New.Id}}</td>
      <td class="p-6">{{item.New.Created | localDateTime}}</td>
      <td class="p-6">{{item.New.UserCalculatedName | replaceOnEmpty }}</td>
      <!--      <td class="p-6 changes">{{calculateLineChanges(item.New) | uppercase }}</td>-->
      <td class="p-6">
        @if (item.New.Source === OrderLineRevisionSource.CUSTOMER) {
          <span class="source-badge source-badge__customer">
            {{'T4.ORDERMUTATIONS.SOURCE.CUSTOMER' | translate}}
          </span>
        }
        @if (item.New.Source !== OrderLineRevisionSource.CUSTOMER) {
          <span class="source-badge source-badge__backoffice">
            {{'T4.ORDERMUTATIONS.SOURCE.BACKOFFICE' | translate}}
          </span>
        }
      </td>
      <td class="p-6">{{item.Old.NewPrice | currency: 'EUR' | replaceOnEmpty}}</td>
      <td class="p-6">{{item.New.NewPrice | currency: 'EUR' | replaceOnEmpty}}</td>
      <td class="p-6 btn-grid">
        <button (click)="openRevisionDialog(item.New)" class="btn btn-primary btn-grid mdi mdi-eye">
          {{'T4.ORDERMUTATIONS.HEADER.SHOW' | translate | uppercase}}
        </button>
      </td>
    </ng-container>
  </ng-container>
</t4-list-view>
